module.exports = __webpack_public_path__ + "img/5.f1d28042.svg";